import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingEstate } from "@tabler/icons-react";
import { CiudadesDef } from "./CiudadesDef";

export const CiudadesIcon = IconBuildingEstate;
export const CiudadesHelpText = "* Aquí puede ver la lista de ciudades de la provincia seleccionada.";

export class Ciudades extends Entity<CiudadesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CiudadesDef(), parentKeys);
        this.Form = import('./CiudadesForm').then((module) => module.CiudadesForm);
        this.Title = "Ciudades";
        this.Icon = CiudadesIcon;
        this.HelpText = CiudadesHelpText;
    }
}